import React from 'react';
import styled from 'styled-components';
import Svg from '_assets/svg';

const Img = styled.img`
    width: 24px;
    height: 24px;
    margin-right: 15px;
`;

const Add = () => {
    return <Img src={Svg.add.default} />
}

export default Add;
